import { observable, action, computed, makeObservable } from "mobx";
import { Fields } from "./Fields";
import { validateVolunteerDemographics } from "../../logic/ValidationChecks";

interface IStubVolunteerFields {
    firstName: string;
    lastName: string;
    birthdate: Date | null;
}

export class StubVolunteer extends Fields<IStubVolunteerFields, StubVolunteer> implements IStubVolunteerFields {
    @observable firstName = "";
    @observable lastName = "";
    @observable birthdate: Date | null = null;

    constructor() {
        super();
        makeObservable(this);
    }

    @action setFirstName(firstName: string) {
        this.firstName = firstName;
    }

    @action setLastName(lastName: string) {
        this.lastName = lastName;
    }

    @action setBirthdate(date: Date | null) {
        this.birthdate = date;
    }

    @computed get validationErrors() {
        return validateVolunteerDemographics(this);
    }

    @computed get serializedData() {
        return {
            firstName: this.trimmed.firstName,
            lastName: this.trimmed.lastName,
            birthdate: this.birthdate
        }
    }
}